import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Snackbar,
  Alert,
  Typography,
  IconButton,
  Box,
  Button,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { clearError } from "store/errorReducer";
import { resetTour } from "store/tourSlice";
import { LOGOUT, MENU_SELECT } from "store/actions";

const ErrorToast2 = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const error = useSelector((state) => state.error.error);

  const handleClose = () => dispatch(clearError());
  if (!error) return null;

  const resetState = () => {
    dispatch({
      type: MENU_SELECT,
      payload: {
        menuItem: "Job Positions",
      },
    });
    dispatch(resetTour());
    dispatch({ type: LOGOUT });
    handleClose();
  };

  const isUnauthorized = error.status === 401;
  const isNetworkError =
    error.message === "Network Error" || error.code === "ERR_NETWORK";

  let title = "Error";
  let message = error.message || "Something went wrong";
  let actionBtn = null;

  if (isUnauthorized) {
    title = "Session Expired";
    message = "Your authentication has expired. Please log in again.";
    actionBtn = (
      <Button size="small" variant="contained" onClick={resetState}>
        Login
      </Button>
    );
  } else if (isNetworkError) {
    title = "HIREdrate Service is unavailable";
    message = "Cannot connect to server";
  }

  return (
    <Snackbar
      open
      autoHideDuration={100000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        // severity="info"
        variant="filled"
        onClose={handleClose}
        sx={{
          backdropFilter: "blur(20px)",
          background: theme.palette.grey[900],
          border: "1px solid rgba(255, 255, 255, 0.18)",
          boxShadow:
            "0 20px 40px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)",
          borderRadius: "20px",
          fontWeight: 500,
          color: "white",
          "& .MuiAlert-icon": {
            color: "rgba(255, 255, 255, 0.8)",
          },
          "& .MuiAlert-message": {
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            py: 1,
          },
        }}
        action={
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ color: "white" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="body2">{message}</Typography>
        {actionBtn && <Box mt={1}>{actionBtn}</Box>}
      </Alert>
    </Snackbar>
  );
};

export default ErrorToast2;
